import { connect } from 'react-redux';
import React, { Component } from 'react';
import styled from 'react-emotion';

import AMPLITUDE_EVENT_NAMES from '../../amplitude/constants';
import CategoryNav from './CategoryNav/CategoryNav';
import Events from './Events/Events';
import { logAmplitudeEvent } from '../../redux/actions/amplitude';
import Style from '../../styles/common';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding-top: ${Style.MEASUREMENT.CATEGORY_NAV.HEIGHT}px;
`;

class Browse extends Component {
  componentDidMount() {
    this.props.logAmplitudeEvent(AMPLITUDE_EVENT_NAMES.BROWSE_SHOW_VIEW);
  }

  render() {
    return (
      <Container>
        <CategoryNav />
        <Events />
      </Container>
    );
  }
}

export default connect(
  () => ({}),
  { logAmplitudeEvent }
)(Browse);



// WEBPACK FOOTER //
// ./src/views/Browse/Browse.js